import { FC } from 'react';

import { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import { MTargetHeader, translateHeaders } from './helpers/HeadersList';
import Grid from '../Grid';
import { AutoCompleteRenderer } from './helpers/customRenderers';
import { listValidator, numberValidator } from '../Validators';
import { requireTitle } from './helpers/utils';

export const MTarget: FC<{
    list: IList;
    toolId: number;
    retailers: string[];
    status: string[];
}> = ({ list, toolId, retailers, status }) => {
    const translatedHeaders = translateHeaders(MTargetHeader);

    return (
        <Grid toolId={toolId} headers={MTargetHeader} list={list}>
            <HotColumn type="text" title={requireTitle(translatedHeaders[0])} />
            <HotColumn
                validator={listValidator(retailers, true)}
                title={translatedHeaders[1]}
                source={retailers}
                type="autocomplete"
            >
                <AutoCompleteRenderer allowEmpty={true} list={retailers} hot-renderer />
            </HotColumn>
            <HotColumn
                validator={listValidator(status)}
                title={translatedHeaders[2]}
                source={status}
                type="autocomplete"
            >
                <AutoCompleteRenderer list={status} hot-renderer />
            </HotColumn>
            <HotColumn type="text" validator={numberValidator(true)} title={translatedHeaders[3]} />
        </Grid>
    );
};
